module.exports = __webpack_public_path__ + "img/HeadPicture.91526928.png";